import { Dialog } from '@primer/react';
import styled from 'styled-components';

const Text = styled('div')`
  color: #3b147a;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  padding: 40px;
`;

export const InfoDialog = ({ setIsOpen, text, title }: { readonly setIsOpen: Function, text: string, title: string }) => {
  return (
    <Dialog
      aria-labelledby="label"
      isOpen
      onDismiss={() => setIsOpen(false)}
      onClick={() => setIsOpen(false)}
      sx={{
        width: '500px',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'initial',
      }}
    >
      <div
        style={{
          height: '80px',
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
          padding: '28px',
          display: 'flex',
          justifyContent: 'center',
          color: '#3B147A',
          textAlign: 'center',
          fontSize: '22px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
        }}
      >
        { title }
      </div>
        <Text>{ text }</Text>
    </Dialog>
  );
};
